module.exports = __webpack_public_path__ + "img/Profile-14.af530cbd.png";